import { Outlet } from 'react-router';

import { Loader } from '../ui/Loader';
import SideMenu from '../ui/section/SideMenu';
import Header from '../ui/section/header/Header';
import { useAuthStore } from '@/store/auth.store';
import { useUIStore } from '@/store/ui.store';

const PrivateLayout = () => {
  const authToken = useAuthStore((state) => state.authToken);
  const isSidebarCollapsed = useUIStore((state) => state.isSidebarCollapsed);

  if (!authToken) {
    return <Loader />;
  }

  return (
    <div className='min-h-screen w-full text-white'>
      <SideMenu />

      <div
        className={`flex min-h-screen flex-col pl-[50px] transition-all duration-300 ${
          isSidebarCollapsed ? 'lg:pl-[50px]' : 'lg:pl-[min(16.5%,280px)]'
        }`}
      >
        <Header />

        <main className='flex-1 px-4 pt-4 lg:px-10 lg:pt-24'>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PrivateLayout;